<template>
  <div class="textarea">
    <textarea
      :id="id"
      ref="textarea"
      v-model="data"
      class="form-control"
      :class="classes"
      :disabled="disabled"
      :style="{
        minHeight: minHeight + 'px',
        maxHeight: maxHeight + 'px'
      }"
      @input="emitEvent"
      @keydown="emitKeydown"
      @change="emitChange"
    ></textarea>
    <label v-if="countChars && charCount" class="textarea__char-count"
      >Znaków {{ charCount }} / {{ maxChars }}</label
    >
    <label v-if="isAllCaps" class="textarea__all-caps"
      >Proszę nie pisać wyłącznie wielkimi literami</label
    >
  </div>
</template>

<script>
import BaseInput from "./BaseInput";

export default {
  name: "BaseTextarea",
  extends: BaseInput,
  props: {
    autoGrow: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: Number,
      default: 300
    },
    minHeight: {
      type: Number,
      default: 100
    }
  },
  watch: {
    value: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.data = newValue;
      }
      this.grow();
    }
  },
  mounted() {
    this.grow();
  },
  methods: {
    emitEvent: function(e) {
      this.$emit("input", event.target ? event.target.value : event);
      this.vTouch();
      this.grow();
    },
    emitKeydown(event) {
      this.$emit("keydown", event);
      this.vTouch();
      this.grow();
    },
    grow: function() {
      if (this.autoGrow) {
        let el = this.$refs.textarea;
        let h = el.scrollHeight;
        el.style.height = `${h}px`;
      }
    }
  }
};
</script>

<style lang="scss">
.textarea {
  &__char-count {
    display: block;
    color: #898989;
    font-size: 0.8em;
    padding-top: 6px;
  }
  &__all-caps {
    display: block;
    color: #e90025;
    font-size: 0.8em;
    padding-top: 6px;
  }
}
</style>
